module.exports = __webpack_public_path__ + "img/product-showcase-image-02.36c00738.jpg";